import { useState, useEffect } from "react";
import { getTheme, toggleTheme, type Theme } from "../lib/theme";

export default function ThemeToggle(): JSX.Element {
  const [theme, setThemeState] = useState<Theme>(getTheme());

  useEffect(() => {
    setThemeState(getTheme());
  }, []);

  return (
    <button
      type="button"
      className="btn"
      onClick={() => setThemeState(toggleTheme())}
      aria-label="Toggle theme"
    >
      {theme === "light" ? "☾ Dark" : "☀ Light"}
    </button>
  );
}
